<template>
<div class="chapter">
<div class="inner_page">
<div class="pg-boilerplate" id="pg-header" lang="en">
<div class="page" id="calibre_pb_0">
<div class="calibre4">
<div class="calibre5">
<table class="tcenter" id="toc">
<thead class="calibre6">
<tr class="calibre7"><td class="calibre8" colspan="2">CONTENTS</td>
</tr>
</thead>
<tbody class="calibre9">
<tr class="calibre7"><td class="tdc">I.</td>
<td class="tdc1"><a class="pginternal" href="#/OEBPS/Text/Section002#chI">Wedding Night</a></td>
</tr>
<tr class="calibre7"><td class="tdc">II.</td>
<td class="tdc1"><a class="pginternal" href="#/OEBPS/Text/Section003#chII">“Hanging is Too Good⸺”</a></td>
</tr>
<tr class="calibre7"><td class="tdc">III.</td>
<td class="tdc1"><span class="pginternal" href="#/OEBPS/Text/Section004#chIII" title="Link target outside of Sample">The New Sheriff</span></td>
</tr>
<tr class="calibre7"><td class="tdc">IV.</td>
<td class="tdc1"><span class="pginternal" href="#/OEBPS/Text/Section005#chIV" title="Link target outside of Sample">Range Funeral</span></td>
</tr>
<tr class="calibre7"><td class="tdc">V.</td>
<td class="tdc1"><span class="pginternal" href="#/OEBPS/Text/Section006#chV" title="Link target outside of Sample">Hashknife and Sleepy</span></td>
</tr>
<tr class="calibre7"><td class="tdc">VI.</td>
<td class="tdc1"><span class="pginternal" href="#/OEBPS/Text/Section007#chVI" title="Link target outside of Sample">Hashknife Smells a Rat</span></td>
</tr>
<tr class="calibre7"><td class="tdc">VII.</td>
<td class="tdc1"><span class="pginternal" href="#/OEBPS/Text/Section008#chVII" title="Link target outside of Sample">City <i class="calibre10">v.</i> Range</span></td>
</tr>
<tr class="calibre7"><td class="tdc">VIII.</td>
<td class="tdc1"><span class="pginternal" href="#/OEBPS/Text/Section009#chVIII" title="Link target outside of Sample">Clues</span></td>
</tr>
<tr class="calibre7"><td class="tdc">IX.</td>
<td class="tdc1"><span class="pginternal" href="#/OEBPS/Text/Section010#chIX" title="Link target outside of Sample">The Inquest</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section001_0001.vue?4c5610be